import {
  doFetchCountries,
  doFetchStates,
  doFetchBasicInfo,
  doFetchChangePassword,
  doValidateAddress,
  doUpdateUserAddress,
  doChangeBasicInfo,
  doFetchEstimatedShippingMethods,
  doShippingInformation,
  doProductsOrder,
  doChangePassword,
  doProductsOrderOnCC,
  doFetchProductPdfs,
  dosetFingerprintWithUserId,
  doSetPaymentInformation,
  doPlaceOrder,
  doDeleteAddress,
  doSetBillingInformation
} from "@/services/user.service";
import { doGetOrderStatus } from "@/services/payment.service";

import { doUpdateSubscription } from "@/services/registration.service";
import {
  invalidPoBoxAddress,
  snakeToCamel,
  camelToSnake,
  shippingLabelMap,
  filterShippingMethods
} from "@/services/util.service";
import { getField, updateField } from "vuex-map-fields";
import {
  listrakEmailCapture
} from "@/services/util.service";
import countries from "@/services/countries";
const isSameAddress = (a = {}, b = {}) => {
  const safe = (v) => (v || "").toString().trim().toLowerCase();

  return (
    safe(a.firstname) === safe(b.firstname) &&
    safe(a.lastname) === safe(b.lastname) &&
    safe(a.postcode) === safe(b.postcode) &&
    safe(a.city) === safe(b.city) &&
    safe(a.countryId) === safe(b.countryId) &&
    Number(a.regionId || 0) === Number(b.regionId || 0) &&
    safe(a.streetNoOne) === safe(b.streetNoOne) &&
    safe(a.streetNoTwo) === safe(b.streetNoTwo)
  );
};
const addresses = {
  regionId: "",
  region: [],
  countryId: "",
  postcode: "",
  city: "",
  telephone: "",
  firstname: "",
  lastname: "",
  company: "",
  defaultShipping: false,
  defaultBilling: false
};
const defaultAddress = {
  defaultShipping: 0,
  defaultBilling: 0
};
const streetNew = {
  streetNoOne: "",
  streetNoTwo: ""
};

export const accountOne = {
  namespaced: true,
  state: {
    one: {},
    address: {},
    addresses: [],
    oneAddress: {},
    addressIndex: null,
    shippingAddressDetails: {},
    billingAddressDetails: {},
    shippingMethods: null,
    changedPasswordFlag: true,
    creditBalance: "$0.00",
    allCountries: [],
    countryWiseStates: [],
    newsLetterSubscription: null,
    errorMessage: null,
    estimatedShipping: [],
    shippingInformation: null,
    inProgress: false,
    paymentInProgress: false,
    userLocalAddress: "",
    userLocalAddressFlag: "",
    userSelectedAddressIndex: 0,
    userLocalBillAddress: "",
    lastAddedAddressBookIndex: -1,
    fetchInProgress: false,
    wrongPasswordMessage: "",
    shippingInformationsInProgress: false,
    addressContainPOBox: null,
    suggestedAddress: {},
    customerNumber: "",

    shippingAddress: {},
    checkoutBillingAddress: {}
  },
  getters: {
    getField
  },
  mutations: {
    updateField,
    setAllCountries(state, allCountries) {
      state.allCountries = allCountries;
    },
    setCountryWiseStates(state, countryWiseStates) {
      state.countryWiseStates = countryWiseStates;
    },
    setOne(state, one) {
      state.one = Object.assign({}, state.one, defaultAddress, one);
      state.one.defaultShipping = Number(state.one.defaultShipping);
      state.one.defaultBilling = Number(state.one.defaultBilling);
      let customerNumber = state.one.customAttributes.filter(
        (customAttribute) =>
          customAttribute.attributeCode === "customer_number",
      )[0];
      if (customerNumber) {
        state.customerNumber = customerNumber.value;
      }
    },
    setAddress(state, address) {
      if (address) {
        state.address = Object.assign({}, state.address, address, streetNew);
        state.address.streetNoOne = address.street[0];
        state.address.streetNoTwo = address.street[1];
        state.address.countryId = state.address.countryId
          ? state.address.countryId
          : "US";
      } else {
        state.address = Object.assign({}, addresses, streetNew);
        state.address.firstname = state.one.firstname;
        state.address.lastname = state.one.lastname;
        state.address.countryId = state.address.countryId
          ? state.address.countryId
          : "US";
      }
    },
    setShippingAddress(state, address) {
      state.shippingAddress = Object.assign(
        {},
        state.address,
        address,
        streetNew,
      );
      state.shippingAddress.streetNoOne = address.street[0];
      state.shippingAddress.streetNoTwo = address.street[1];
      state.shippingAddress.countryId ??= state.address.countryId ?? "US";
    },
    setSuggestedAddress(state, addressNew) {
      if (addressNew) {
        state.suggestedAddress = Object.assign(
          {},
          state.suggestedAddress,
          addressNew,
          streetNew,
        );
        state.suggestedAddress.streetNoOne = addressNew.street[0];
        state.suggestedAddress.streetNoTwo = addressNew.street[1];
      } else {
        state.suggestedAddress = Object.assign({}, addresses, streetNew);
      }
    },
    setAddresses(state, { addresses, addressId }) {
      let newAddressArray = [];
      state.shippingAddressDetails = { index: null };
      state.billingAddressDetails = { index: null };
      addresses.forEach(function (address, index) {
        let addr = {};
        addr = Object.assign({}, state.address, address, streetNew);
        addr.streetNoOne = address.street[0];
        addr.streetNoTwo = address.street[1];

        if (address.defaultShipping) {
          state.shippingAddressDetails.address = address;
          state.shippingAddressDetails.index = index;
        }

        if (address.defaultBilling) {
          state.billingAddressDetails.address = address;
          state.billingAddressDetails.index = index;
        }

        if (addressId == addr.id) {
          state.address = addr;
          state.addressIndex = index;
        }

        newAddressArray.push(addr);
      });
      state.addresses = newAddressArray;
    },
    setLocalShippAddress(state, address) {
      state.address = Object.assign({}, address);
      state.userLocalAddress = address;
    },
    resetLocalShippAddressVar(state, val) {
      state.userLocalAddress = val;
    },
    setLocalBillAddress(state, address) {
      state.address = Object.assign({}, address);
      state.userLocalBillAddress = address;
    },
    setLocalShippAddressFlag(state, flag) {
      state.userLocalAddressFlag = flag;
    },
    setSelectedShippAddressIndex(state, index) {
      state.userSelectedAddressIndex = index;
    },
    lastAddedAddressBookIndex(state, index) {
      state.lastAddedAddressBookIndex = index;
    },
    deleteAddress(state, address) {
      const index = state.addresses.indexOf(address);
      if (index > -1) {
        state.addresses.splice(index, 1);
      }
    },
    updateAddresses(state, address) {
      if (state.addressIndex !== null) {
        state.addresses[state.addressIndex] = address;
      } else {
        state.addresses.push(address);
        state.addressIndex = state.addresses.length - 1;
      }
      state.addresses = state.addresses.map((addr, index) => {
        if (state.addressIndex !== index) {
          if (address.defaultBilling) addr.defaultBilling = false;
          if (address.defaultShipping) addr.defaultShipping = false;
        }
        return addr;
      });
    },
    // called from me module action to format user address
    formatUserAddress(state) {
      let streetAddress = [];
      let streetArray = [];
      if (state.address) {
        if (
          state.address.streetNoTwo == " " ||
          state.address.streetNoTwo == undefined
        ) {
          streetAddress[0] = state.address.streetNoOne;
          streetArray = streetAddress.filter((v) => v != "");
        } else {
          streetAddress[0] = state.address.streetNoOne;
          streetAddress[1] = state.address.streetNoTwo;
          streetArray = streetAddress.filter((v) => v != "");
        }
        let formatedAddress = {
          id: state.address.id,
          regionId: state.address.regionId,
          countryId: state.address.countryId,
          street: streetArray,
          postcode: state.address.postcode,
          city: state.address.city,
          telephone: state.address.telephone,
          firstname: state.address.firstname,
          lastname: state.address.lastname,
          company: state.address.company,
          defaultBilling: state.address.defaultBilling,
          defaultShipping: state.address.defaultShipping
        };
        state.address = formatedAddress;
      }
    },
    formatAddresses(state) {
      let addrs = [];
      let streetAddress = [];
      let streetArray = [];
      state.addresses.forEach(function (address) {
        if (address.streetNoTwo == " " || address.streetNoTwo == undefined) {
          streetAddress[0] = address.streetNoOne;
          streetArray = streetAddress.filter((v) => v != "");
        } else {
          streetAddress[0] = address.streetNoOne;
          streetAddress[1] = address.streetNoTwo;
          streetArray = streetAddress.filter((v) => v != "");
        }
        let formatedAddress = {
          id: address.id,
          region_id: address.regionId,
          country_id: address.countryId,
          street: streetArray,
          postcode: address.postcode,
          city: address.city,
          telephone: address.telephone,
          firstname: address.firstname,
          lastname: address.lastname,
          company: address.company,
          default_billing: address.defaultBilling,
          default_shipping: address.defaultShipping
        };
        addrs.push(formatedAddress);
      });
      state.addresses = addrs;
    },
    setChangePasswordFlag(state, changedPasswordFlag) {
      state.changedPasswordFlag = changedPasswordFlag;
    },
    setEstimatedShipping(state, shipping) {
      state.estimatedShipping = shipping.map((item) => {
        const key = `${item.carrierCode}|${item.methodCode}`;
        return {
          ...item,
          label: shippingLabelMap[key] || item.methodTitle // fallback
        };
      });
    },
    /*successMessage(state, successMessage) {
            state.successMessage = successMessage;
        },*/
    inProgress(state, yesOrNo) {
      state.inProgress = yesOrNo;
    },
    shippingInformationsInProgress(state, yesOrNo) {
      state.shippingInformationsInProgress = yesOrNo;
    },
    fetchInProgress(state, yesOrNo) {
      state.fetchInProgress = yesOrNo;
    },
    wrongPasswordMessage(state, message) {
      state.wrongPasswordMessage = message;
    },
    errorMessage(state, error) {
      state.errorMessage = error;
    },
    setShippingInformation(state, shippingInformation) {
      state.shippingInformation = shippingInformation;
    },
    formatOneAddress(state) {
      let streetAddress = [];
      let streetArray = [];
      if (
        state.address.streetNoTwo == " " ||
        state.address.streetNoTwo == undefined
      ) {
        streetAddress[0] = state.address.streetNoOne;
        streetArray = streetAddress.filter((v) => v != "");
      } else {
        streetAddress[0] = state.address.streetNoOne;
        streetAddress[1] = state.address.streetNoTwo;
        streetArray = streetAddress.filter((v) => v != "");
      }
      let formatedAddress = {
        region_id: state.address.regionId,
        country_id: state.address.countryId,
        street: streetArray,
        postcode: state.address.postcode,
        city: state.address.city,
        telephone: state.address.telephone,
        firstname: state.address.firstname,
        lastname: state.address.lastname
      };
      state.oneAddress = formatedAddress;
    },
    paymentInProgress(state, yesOrNo) {
      state.paymentInProgress = yesOrNo;
    },
    checkPOBoxAddress(state, address) {
      if (address && typeof address == "object") {
        let streetAddress = address.street ? address.street : [];
        if (!streetAddress.length && address.streetNoOne) {
          streetAddress[0] = address.streetNoOne;
          streetAddress[1] = address.streetNoTwo;
        }
        if (streetAddress && streetAddress.length) {
          if (streetAddress[0]) {
            if (invalidPoBoxAddress(streetAddress[0])) {
              state.addressContainPOBox = true;
            } else {
              state.addressContainPOBox = false;
            }
          }
          if (streetAddress[1]) {
            if (invalidPoBoxAddress(streetAddress[1])) {
              state.addressContainPOBox = true;
            } else {
              state.addressContainPOBox = false;
            }
          }
        }
      } else if (address && typeof address == "string") {
        if (invalidPoBoxAddress(address)) {
          state.addressContainPOBox = true;
        } else {
          state.addressContainPOBox = false;
        }
      }
    },
    setCheckoutBillingAddress(state, address) {
      state.checkoutBillingAddress = {
        ...address,
        streetNoOne: address.streetNoOne || address.street?.[0] || "",
        streetNoTwo: address.streetNoTwo || address.street?.[1] || "",
      };
    },

  },
  actions: {
    fetchStates: async ({ commit }) => {
      try {
        const countryAllStates = await doFetchStates();
        if (countryAllStates) {
          commit("setCountryWiseStates", snakeToCamel(countryAllStates));
        }
      } catch (err) {
        commit("errorMessage", err.message);
      }
    },
    fetchCountries: async ({ commit }) => {
      try {
        const allCountries = await doFetchCountries();
        if (allCountries) {
          commit("setAllCountries", snakeToCamel(allCountries));
        }
      } catch (err) {
        commit("errorMessage", err.message);
      }
    },
    basicInfo: async ({ state, commit, dispatch, rootState }, addressId) => {
      try {
        commit("inProgress", true);
        commit("fetchInProgress", true);
        const basicInfo = await doFetchBasicInfo();
        if (basicInfo) {

          commit("setOne", snakeToCamel(basicInfo));

          commit("setAddresses", {
            addresses: snakeToCamel(basicInfo.addresses),
            addressId: addressId
          });
          listrakEmailCapture(basicInfo.email);
        }
        commit("inProgress", false);
        commit("fetchInProgress", false);
      } catch (err) {
        commit("inProgress", false);
        commit("fetchInProgress", false);

        commit("errorMessage", err.message);
      }
    },
    changePassword: async ({ commit }, { currentPassword, newPassword }) => {
      try {
        const changedPassword = await doFetchChangePassword(
          currentPassword,
          newPassword,
        );
        commit("setChangePasswordFlag", changedPassword);
      } catch (err) {
        commit("errorMessage", err.message);
      }
    },
    //// called from me module to update user address
    updateUserAddress: async ({ state, commit }) => {
      try {
        commit("inProgress", true);
        commit("formatUserAddress");
        const basicInfo = await doUpdateUserAddress(camelToSnake(state.address));
        if (basicInfo) {
          commit("setOne", snakeToCamel(basicInfo));
          commit("setAddresses", {
            addresses: snakeToCamel(basicInfo.addresses)
          });
          commit("inProgress", false);
        }
      } catch (err) {
        commit("errorMessage", err.message);
        commit("inProgress", false);
      }
    },
    updateAddress: async ({ state, commit }) => {
      try {
        commit("inProgress", true);
        commit("updateAddresses", state.address);
        commit("formatAddresses");
        const basicInfo = await doUpdateUserAddress(
          state.one,
          state.addresses,
          state.customerNumber,
        );
        if (basicInfo) {
          commit("inProgress", false);
          commit("setOne", snakeToCamel(basicInfo));
          commit("setAddresses", {
            addresses: snakeToCamel(basicInfo.addresses)
          });
        }
      } catch (err) {
        commit("errorMessage", err.message);
        commit("inProgress", false);
      }
    },
    updateSubscription: async ({ state, commit }, isSubscribed) => {
      commit("inProgress", true);
      try {
        await doUpdateSubscription(isSubscribed);
        commit("inProgress", false);
      } catch (err) {
        commit("inProgress", false);
        throw err;
      }
    },
    updatePassword: async ({ state, commit }, passwords) => {
      commit("inProgress", true);
      try {
        if (passwords == undefined) {
          // This case seems unused, but keeping for compatibility
          let customer = {
            firstname: state.one.firstname,
            lastname: state.one.lastname,
            middlename: state.one.middlename,
            prefix: state.one.prefix,
            suffix: state.one.suffix,
            taxvat: state.one.taxvat,
            gender: state.one.gender,
            date_of_birth: state.one.date_of_birth,
            is_subscribed: state.one.is_subscribed,
            custom_attributes: [
              {
                attribute_code: "customer_number",
                value: state.customerNumber
              }
            ]
          };
          const basicInfo = await doChangeBasicInfo(customer);
          if (basicInfo) {
            commit("inProgress", false);

            commit("setOne", snakeToCamel(basicInfo));
          }
        } else {
          // Change password only
          await doChangePassword(passwords.current, passwords.new);
          commit("inProgress", false);
          return { error: false };
        }
      } catch (err) {
        commit("errorMessage", err.message);
        commit("inProgress", false);
        return { error: true, message: err.message };
      }
    },
    changeBasicInfo: async ({ state, commit }, data) => {
      commit("inProgress", true);
      try {
        const basicInfo = await doChangeBasicInfo(data);
        commit("inProgress", false);

        commit("setOne", snakeToCamel(basicInfo));
      } catch (err) {
        commit("errorMessage", err.message);
        commit("inProgress", false);
      }
    },

    validateAddress: async ({ commit, state, dispatch }, address) => {
      try {
        if (state.allCountries.length == 0) {
          await dispatch("fetchCountries");
        }

        const { fetchStates } = await import("@/services/util.service");

        let stateNameList = fetchStates(address.countryId, state.allCountries);
        let stateName = stateNameList.filter((obj) => {
          if (obj.value == address.regionId) return obj;
        });
        stateName = stateName && stateName.length ? stateName[0].label : "";

        const validatedAddress = await doValidateAddress(address, stateName);
        return validatedAddress;
      } catch (err) {
        commit("errorMessage", err.message);
      }
    },
    validateAddressCheckout: async ({ commit }, { address, stateName }) => {
      commit("setSuggestedAddress", null);
      try {
        const validatedAddress = await doValidateAddress(address, stateName);
        return validatedAddress;
      } catch (err) {
        commit("errorMessage", err.message);
      }
    },
    setEstimatedShipping: async ({ state, rootState, commit }) => {
      commit("inProgress", true);
      try {
        const userQuote = rootState.userCartProduct.cartProductList[0].id;
        const shippMethods = await doFetchEstimatedShippingMethods(
          userQuote,
          state.address
        );
        commit(
          "setEstimatedShipping",
          snakeToCamel(filterShippingMethods(shippMethods))
        );
        return shippMethods;
      } catch (err) {
        throw err;
      } finally {
        commit("inProgress", false);
      }
    },
    setShippingInformation: async ({ state, rootState, commit }, method) => {
      commit("shippingInformationsInProgress", true);
      try {
        commit("checkPOBoxAddress", state.address);
        let quoteId = rootState.userCartProduct.cartProductList[0].id;
        const shippingInformation = await doShippingInformation(
          quoteId,
          state.one,
          state.address,
          method,
          state.suggestedAddress,
        );
        commit("shippingInformationsInProgress", false);
        commit("setShippingInformation", snakeToCamel(shippingInformation));
        localStorage.setItem("cr_checkOutTab", "reviewTab");
      } catch (err) {
        commit("shippingInformationsInProgress", false);
        throw err;
      }
    },
    setShippingAddress: async ({ state, commit }) => {
      commit("checkPOBoxAddress", state.address);
      localStorage.setItem(
        "cr_" + state.one.id + "_userNewShippAddress",
        JSON.stringify(state.address),
      );
      localStorage.setItem(
        "cr_" + state.one.id + "_userNewShippAddressFlag",
        true,
      );
      commit("setLocalShippAddress", state.address);
    },
    setLocalShippAddress: async ({ commit }, address) => {
      commit("setLocalShippAddress", address);
      commit("checkPOBoxAddress", address);
    },
    resetLocalShippAddressVar: async ({ commit }, val) => {
      commit("resetLocalShippAddressVar", val);
    },
    setSelectedShippAddressIndex: async ({ state, commit }, index) => {
      localStorage.setItem(
        "cr_" + state.one.id + "_userSelectedShippAddressIndex",
        index,
      );
      commit("setSelectedShippAddressIndex", index);
    },
    lastAddedAddressBookIndex: async ({ state, commit }, index) => {
      localStorage.setItem(
        "cr_" + state.one.id + "_lastAddedAddressBookIndex",
        index,
      );
      commit("lastAddedAddressBookIndex", index);
    },
    setLocalShippAddressFlag: async ({ state, commit }, flag) => {
      localStorage.setItem(
        "cr_" + state.one.id + "_userNewShippAddressFlag",
        flag,
      );
      commit("setLocalShippAddressFlag", flag);
    },
    setLocalBillAddress: async ({ state, commit }, address) => {
      localStorage.setItem(
        "cr_" + state.one.id + "_userNewBillAddress",
        JSON.stringify(address),
      );
      commit("setLocalBillAddress", address);
      commit("checkPOBoxAddress", address);
    },
    setAddress: async ({ commit }, address) => {
      commit("setAddress", address);
      commit("checkPOBoxAddress", address);
    },
    checkPOBoxAddress: async ({ commit }, address) => {
      commit("checkPOBoxAddress", address);
    },
    deleteAddress: async ({ state, commit }, address) => {
      commit("fetchInProgress", true);
      try {
        commit("deleteAddress", address);
        let resp = await doDeleteAddress(address.id);
        if (!resp?.success) {
          throw new Error("Error in deletion");
        }
        commit("fetchInProgress", false);
        return resp;
      } catch (err) {
        console.error("Backend delete failed:", err);
        commit("fetchInProgress", false);
        commit("errorMessage", err.message);
        return { success: false, errorMesage: err.message };
      }
    },
    placeCustomerOrder: async (
      { state, rootState, commit },
      { paymentMethod }
    ) => {
      try {
        commit("paymentInProgress", true);
        commit("checkPOBoxAddress", state.oneAddress);
        commit("formatOneAddress");
        const userQuote = rootState.userCartProduct.cartProductList[0].id;
        if (userQuote) {
          let res = await doProductsOrder(userQuote, paymentMethod);
          commit("paymentInProgress", false);
          return res;
        }
      } catch (error) {
        commit("errorMessage", error.message);
        commit("paymentInProgress", false);
        throw error;
      }
    },
    setPaymentInProgress: async ({ commit }, flag) => {
      commit("paymentInProgress", flag);
    },
    setCCOrder: async (
      { commit },
      { orderNumber, shippingAddress, webOrderNumber, estimatedShipping },
    ) => {
      try {
        await doProductsOrderOnCC(
          orderNumber,
          shippingAddress,
          webOrderNumber,
          estimatedShipping,
        );
      } catch (error) {
        console.error("error", error.message);
        commit("errorMessage", error.message);
      }
    },
    fetchProductPdfs: async ({ commit }, { orderNumber, itemId }) => {
      try {
        let pdfArray = await doFetchProductPdfs(orderNumber, itemId);
        return snakeToCamel(pdfArray);
      } catch (error) {
        commit("errorMessage", error.message);
      }
    },

    setUserAddress: async ({ commit }, address) => {
      commit("setSuggestedAddress", address);
    },
    getCustomerInfo: async ({ state, commit }) => {
      try {
        commit("inProgress", true);
        commit("fetchInProgress", true);
        const info = await doFetchBasicInfo();
        return info;
      } catch (error) {
        console.log("error in getting customer info", error);
        return null;
      }
    },
    setFingerprintWithUserId: async ({ state, commit }, basicData) => {
      try {
        const info = await dosetFingerprintWithUserId(basicData);

        return info;
      } catch (error) {
        console.log("error in getting setFingerprintWithUserId info", error);
        return null;
      }
    },
    setShippingDetails: ({ commit }, address) => {
      commit("setShippingAddress", address);
    },
    fetchEstimatedShippingOptions: async ({ state, rootState, commit }) => {
      try {
        commit("inProgress", true);
        let quoteId = rootState.userCartProduct.cartProductList[0].id;
        const shippMethods = await doFetchEstimatedShippingMethods(
          quoteId,
          state.shippingAddress
        );

        if (shippMethods && shippMethods.length > 0) {
          // listrakEmailCapture(email);
          commit(
            "setEstimatedShipping",
            snakeToCamel(filterShippingMethods(shippMethods))
          );
        } else {
          // throw {
          //   message:
          //     "Shipping to the provided address is not available. Please verify your address or choose an alternative location.",
          // };
        }
      } catch (err) {
        throw err;
      } finally {
        commit("inProgress", false);
      }
    },
    setUserShippingInformation: async (
      { state, rootState, commit, dispatch },
      data
    ) => {
      commit("shippingInformationsInProgress", true);
      dispatch("userCartProduct/cartTotalAmtProgress", true, { root: true });
      try {
        let quoteId = rootState.userCartProduct.cartProductList[0].id;
        commit("checkPOBoxAddress", state.address);
        await doShippingInformation(
          quoteId,
          state.one,
          state.shippingAddress,
          data.method,
          state.shippingAddress,
        );
        // commit("setShippingInformation", snakeToCamel(shippingInformation));

        // return state.shippingInformation;
      } catch (err) {
        throw err;
      } finally {
        commit("shippingInformationsInProgress", false);
        dispatch("userCartProduct/cartTotalAmtProgress", false, { root: true });
      }
    },

    setPaymentInformation: async (
      { state, commit },
      { email, quoteId, paymentMethod, billingAddress },
    ) => {
      try {
        commit("paymentInProgress", true);
        commit("checkPOBoxAddress", state.billingAddress);
        commit("formatOneAddress");
        if (!quoteId) {
          throw {
            message: "Missing quote ID. Unable to proceed with order placement."
          };
        }
        let res = await doSetPaymentInformation({
          quoteId,
          email,
          paymentMethod,
          billingAddress
        });
        commit("paymentInProgress", false);
        return res;
      } catch (error) {
        // commit('errorMessage', error.message);
        throw error;
      } finally {
        commit("paymentInProgress", false);
      }
    },
    placeOrder: async ({ state, commit }, quoteId) => {
      try {
        commit("paymentInProgress", true);
        commit("formatOneAddress");
        commit("checkPOBoxAddress", snakeToCamel(state.address));

        if (!quoteId) {
          throw {
            message: "Missing quote ID. Unable to proceed with order placement."
          };
        }

        let res = await doPlaceOrder(quoteId);
        return res;
      } catch (error) {
        commit(
          "errorMessage",
          error.message || "An error occurred while placing the order.",
        );
        throw error;
      } finally {
        commit("paymentInProgress", false);
      }
    },
    setBillingInformation: async ({ rootState, commit }, { email, billingDetails }) => {
      try {
        let quoteId = rootState.userCartProduct.cartProductList[0].id;
        let address = billingDetails.address;

        let countryData = countries[address.country];
        const region = countryData.available_regions.find(
          (r) => r.code.toUpperCase() === address.state.toUpperCase(),
        );

        if (!region) {
          throw {
            message:
              "The selected region is not available. Please verify your billing address and try again."
          };
        }

        // Process names
        const splitName = billingDetails.name.split(/ (.+)/);
        if (splitName.length < 2 || !splitName[0] || !splitName[1]) {
          throw {
            message:
              "Please provide both first name and last name in billing details."
          };
        }

        const billingAddress = {
          regionId: region.id,
          countryId: address.country,
          postcode: address.postal_code,
          city: address.city,
          street: [address.line1, address.line2],
          telephone: billingDetails.phone,
          firstname: splitName[0],
          lastname: splitName[1]
        };

        // Step 1: set payment
        const setBillingResponse = await doSetBillingInformation(
          quoteId,
          billingAddress,
          email
        );
        commit("setCheckoutBillingAddress", billingAddress);

        if (!setBillingResponse)
          throw {
            message:
              "Unable to proceed with order placement. Please verify the provided details and try again."
          };
      } catch (error) {
        throw {
          message:
            "Error in setting billing address, please check provided information and try again"
        };
      }
    },
    processPayment: async (
      { dispatch, commit },
      { paymentMethod, paymentProcessed }
    ) => {
      try {
        let orderResponse;

        if (!paymentProcessed) {
          // Step 1: place order
          orderResponse = await dispatch("placeCustomerOrder", {
            paymentMethod
          });
        } else {
          orderResponse = await dispatch("placeCustomerOrder", {
            paymentMethod
          });
        }
        await dispatch("handleCheckoutAddress");
        setTimeout(() => {
          dispatch("userCartProduct/setUserQuoteId", null, { root: true });
          dispatch("userCartProduct/cartProductList", "", { root: true });
          commit("setEstimatedShipping", []);
        }, 0);
        return {
          order: orderResponse,
          orderId: orderResponse.incrementId
        };

        // if (orderResponse?.payment?.type.toLowerCase() === "free") {
        //   dispatch("userCartProduct/setUserQuoteId", null, {
        //     root: true
        //   });
        //   dispatch("userCartProduct/cartProductList", "", {
        //     root: true
        //   });
        //   const order = await dispatch(
        //     "meProductOne/fetchOrderProduct",
        //     orderResponse.incrementId,
        //     { root: true }
        //   );
        //   return { order: order, orderId: orderResponse.incrementId };
        // }

        // // Step 2: wait until all items are "processing"
        // return new Promise((resolve, reject) => {
        //   const intervalId = setInterval(async () => {
        //     try {
        //       const order = await dispatch("fetchOrderStatus", {
        //         incrementId: orderResponse.incrementId
        //       });

        //       if (order?.status.toLowerCase() === "payment_failure") {
        //         clearInterval(intervalId);
        //         dispatch("userCartProduct/setUserQuoteId", null, {
        //           root: true
        //         });
        //         dispatch("userCartProduct/cartProductList", "", {
        //           root: true
        //         });
        //         commit("setEstimatedShipping", []);
        //         reject({
        //           status: "payment_failure",
        //           message:
        //             "Your order has been placed successfully; however, there was an issue with the payment. Please contact the service desk for assistance."
        //         });
        //       }

        //       if (
        //         order?.status.toLowerCase() === "processing" ||
        //         order?.status.toLowerCase() === "complete"
        //       ) {
        //         clearInterval(intervalId);
        //         dispatch("userCartProduct/setUserQuoteId", null, {
        //           root: true
        //         });
        //         dispatch("userCartProduct/cartProductList", "", {
        //           root: true
        //         });
        //         commit("setEstimatedShipping", []);
        //         resolve({
        //           order: { ...orderResponse, status: order.status },
        //           orderId: orderResponse.incrementId
        //         }); // ✅ return order when ready
        //       }
        //     } catch (err) {
        //       clearInterval(intervalId);
        //       reject(err); // stop polling on error
        //     }
        //   }, 4000); // poll every 4s
        // });
      } catch (error) {
        throw error;
      }
    },
    fetchOrderStatus: async ({ }, { incrementId }) => {
      try {
        let response = await doGetOrderStatus({
          incrementId
        });

        return response;
      } catch (error) {
        console.error("Error fetching order details:", error);
        throw error;
      }
    },
    handleCheckoutAddress: async ({ state, dispatch, commit }) => {
      try {
        const normalize = (addr = {}) => ({
          ...addr,
          streetNoOne: addr.streetNoOne || addr.street?.[0] || "",
          streetNoTwo: addr.streetNoTwo || addr.street?.[1] || "",
        });

        let addressBook = [...state.addresses];

        const shipping = normalize(state.shippingAddress);
        const billing = normalize(state.checkoutBillingAddress || shipping);

        const isSame = isSameAddress(shipping, billing);

        //   SAME ADDRESS
        if (isSame) {
          const existing = addressBook.find(addr =>
            isSameAddress(normalize(addr), shipping)
          );

          if (existing?.defaultShipping && existing?.defaultBilling) return;

          const updated = {
            ...shipping,
            defaultShipping: true,
            defaultBilling: true,
          };

          if (existing) updated.id = existing.id;
          else delete updated.id;

          commit("setAddress", updated);
          await dispatch("updateUserAddress");

          return;
        }

        //  DIFFERENT ADDRESS

        await dispatch("handleAddress", {
          address: shipping,
          addressBook,
          type: "shipping"
        });

        // refresh after update
        addressBook = [...state.addresses];

        await dispatch("handleAddress", {
          address: billing,
          addressBook,
          type: "billing"
        });

      } catch (err) {
        console.error(err);
      }
    },
    handleAddress: async (
      { commit, dispatch },
      { address, addressBook, type }
    ) => {
      const normalize = (addr) => ({
        ...addr,
        streetNoOne: addr.streetNoOne || addr.street?.[0] || "",
        streetNoTwo: addr.streetNoTwo || addr.street?.[1] || "",
      });

      const normalizedAddress = normalize(address);

      const existing = addressBook.find(addr =>
        isSameAddress(normalize(addr), normalizedAddress)
      );

      // EXISTING
      if (existing) {
        if (
          (type === "shipping" && existing.defaultShipping) ||
          (type === "billing" && existing.defaultBilling)
        ) {
          return;
        }

        const updated = {
          ...normalizedAddress,
          defaultShipping: type === "shipping",
          defaultBilling: type === "billing",
          id: existing.id,
        };

        commit("setAddress", updated);
        await dispatch("updateUserAddress");
      }

      // NEW
      else {
        const updated = {
          ...normalizedAddress,
          defaultShipping: type === "shipping",
          defaultBilling: type === "billing",
        };

        delete updated.id;

        commit("setAddress", updated);
        await dispatch("updateUserAddress");
      }
    }
  }
};
